import React from 'react';
import colors from 'theme/_colors.scss';

const IconView = ({ width = 16, height = 16, viewBox = '0 0 16 16', color = colors.black, onClick }) => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' onClick={onClick} width={width} height={height} viewBox={viewBox} fill='none'>
			<path d='M7.99 9.48C8.38782 9.48 8.76936 9.32196 9.05066 9.04066C9.33196 8.75936 9.49 8.37782 9.49 7.98C9.49 7.58218 9.33196 7.20064 9.05066 6.91934C8.76936 6.63804 8.38782 6.48 7.99 6.48C7.59218 6.48 7.21064 6.63804 6.92934 6.91934C6.64804 7.20064 6.49 7.58218 6.49 7.98C6.49 8.37782 6.64804 8.75936 6.92934 9.04066C7.21064 9.32196 7.59218 9.48 7.99 9.48V9.48ZM8 3C4.85 3 2 4.89 0 8C2 11.08 4.85 13 8 13C11.15 13 14 11.1 16 8C14 4.94 11.15 3 8 3ZM8 11C7.20435 11 6.44129 10.6839 5.87868 10.1213C5.31607 9.55871 5 8.79565 5 8C5 7.20435 5.31607 6.44129 5.87868 5.87868C6.44129 5.31607 7.20435 5 8 5C8.79565 5 9.55871 5.31607 10.1213 5.87868C10.6839 6.44129 11 7.20435 11 8C11 8.79565 10.6839 9.55871 10.1213 10.1213C9.55871 10.6839 8.79565 11 8 11Z' fill={color}/>
		</svg>
	);
};

export default IconView;
